export enum FlashBagType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
